(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class PetPersonalizationFields extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      document.addEventListener('variant:update', this.handleVariantUpdate, {
        signal: this.abortController.signal,
      });

      this.engravingInput = this.querySelector('[data-engraving-input]');
      this.engravingInput?.addEventListener('input', this.validateEngraving, {
        signal: this.abortController.signal,
      });

      const variantInput = this.closest('product-form-component')?.querySelector('input[name="id"]');
      this.updateEngravingField(variantInput?.value || '');
      this.updatePhotoField(variantInput?.value || '');
      this.validateEngraving();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    handleVariantUpdate = (event) => {
      const variantId = String(event.detail?.resource?.id || '');
      const productVariantIds = this.dataset.productVariantIds?.trim().split(/\s+/) || [];

      if (!productVariantIds.includes(variantId)) return;
      this.updateEngravingField(variantId);
      this.updatePhotoField(variantId);
    };

    validateEngraving = () => {
      if (!this.engravingInput) return;

      const value = this.engravingInput.value;
      const containsChinese = /[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/u.test(value);
      const exceedsChineseLimit = containsChinese && Array.from(value).length > 3;

      this.engravingInput.setCustomValidity(
        exceedsChineseLimit ? 'If the engraving contains Chinese, enter no more than 3 characters.' : ''
      );
    };

    updateEngravingField(variantId) {
      const engravingVariantIds = this.dataset.engravingVariantIds?.trim().split(/\s+/) || [];
      const engravingField = this.querySelector('[data-engraving-field]');
      const engravingInput = engravingField?.querySelector('input');
      const engravingSelected = engravingVariantIds.includes(String(variantId));

      if (!engravingField || !engravingInput) return;
      engravingField.hidden = !engravingSelected;
      engravingInput.disabled = !engravingSelected;
      engravingInput.required = engravingSelected;
    }

    updatePhotoField(variantId) {
      const photoVariantIds = this.dataset.photoVariantIds?.trim().split(/\s+/) || [];
      const photoField = this.querySelector('[data-photo-field]');
      const photoInput = photoField?.querySelector('input[type="file"]');
      const photoSelected = photoVariantIds.includes(String(variantId));

      if (!photoField || !photoInput) return;
      photoField.hidden = !photoSelected;
      photoInput.disabled = !photoSelected;
      photoInput.required = photoSelected;
    }
  }

  if (!customElements.get('pet-personalization-fields')) {
    customElements.define('pet-personalization-fields', PetPersonalizationFields);
  }
  } catch(e) { console.error(e); }
})();

})();
